import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";

var head = require("lodash/head");

var find = require("lodash/find");

import { StatefulAccessor } from "./StatefulAccessor";
import { ValueState } from "../../core";
export var ViewOptionsAccessor =
/*#__PURE__*/
function (_StatefulAccessor) {
  _inherits(ViewOptionsAccessor, _StatefulAccessor);

  function ViewOptionsAccessor(key, options) {
    var _this;

    _classCallCheck(this, ViewOptionsAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewOptionsAccessor).call(this, key));
    _this.state = new ValueState();
    _this.options = options;
    return _this;
  }

  _createClass(ViewOptionsAccessor, [{
    key: "getSelectedOption",
    value: function getSelectedOption() {
      return find(this.options, {
        key: this.state.getValue()
      }) || find(this.options, {
        defaultOption: true
      }) || head(this.options);
    }
  }, {
    key: "setView",
    value: function setView(key) {
      var view = find(this.options, {
        key: key
      });

      if (view) {
        if (view.defaultOption) {
          this.state = this.state.clear();
        } else {
          this.state = this.state.setValue(view.key);
        }

        this.search();
      }
    }
  }, {
    key: "search",
    value: function search() {
      //this won't fire search as query didn't change, but it will serialize url
      //might need better way
      this.searchkit.performSearch(false, false);
      this.searchkit.emitter.trigger();
    }
  }]);

  return ViewOptionsAccessor;
}(StatefulAccessor);